import React from "react";

const RenderArea = ({
  input,
  type,
  className,
  rows,
  meta: { touched, error },
}) => (
  <div className="position-relative w-100">
    <textarea
      {...input}
      type={type}
      className={className}
      rows={rows}
      onFocus={(e) => e.currentTarget.select()}
      style={{
        borderColor: `${touched && error ? "#FF0000" : "#c6cbd2"}`,
      }}
    />
    {touched && error && (
        <div
          style={{
            color: '#FF0000',
            margin: '0',
            fontSize: '0.75rem',
          }}
        >
          {error}
        </div>
      )}
  </div>
);

export default RenderArea;
